SlideView = require("views/slide")

class TableView extends SlideView
  template: require("./template")

  events: ->
    "iostap .btn-done": "submit"

  serialize: ->
    data = super

    data.isNumber   = (el) -> /^[\.\,\d\$£€\%\-\s]+$/.test(el)
    data.longestRow = _.max data.rows, (r) -> r.cells?.length || 0
    data.classes    = _.chain(data.style)
      .omit("scrollable", "header")
      .reduce(((str, v, k) -> if v then str + " table-#{k}" else str), "")
      .value()

    data

  beforeShow: ->
    @trigger("ui", flexibleHeight: true)
    table  = @findOne(".table")
    parent = table.parentNode

    if table.offsetWidth > parent.offsetWidth
      @setState(true, "scroll")
      parent.addEventListener "scroll", _.bind(@onScroll, this)
      @onScroll(target: parent)
    else
      @setState(false, "scroll")

  beforeHide: ->
    @trigger("ui", flexibleHeight: false)

  onRefresh: ->
    @beforeShow()

  onScroll: (e) ->
    el = e.target

    if el.scrollLeft <= 0
      @setState "left", "scroll-pos"
    else if el.scrollLeft >= el.scrollWidth - el.offsetWidth
      @setState "right", "scroll-pos"
    else
      @setState "between", "scroll-pos"

module.exports = TableView
